// hooks/useIntersection.js
import { useState, useEffect, useRef } from 'react';

export default function useIntersection(options) {
  const containerRef = useRef(null);
  const [isIntersecting, setIsIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      // Если секция на 100% в зоне видимости (threshold: 1),
      // то считаем, что блок «полностью виден»
      if (entry.isIntersecting) {
        setIsIntersecting(true);
        // Если хотим анимировать только один раз,
        // то «отвязываемся» от наблюдения
        observer.unobserve(containerRef.current);
      }
    }, options);

    if (containerRef.current) {
      observer.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        observer.unobserve(containerRef.current);
      }
    };
  }, [containerRef, options]);

  return [containerRef, isIntersecting];
}